import { XNativeDialog } from '@adornis/dialog/x-native-dialog.js';
import { clientTranslator } from '@adornis/translation-core/client/clientTranslator.js';
import { ExamType } from '@ils/static/enums.js';
import { getToneForExamType } from '@ils/theme/theme.js';
import { html } from 'lit';

export const promptForExamType = (title = 'Welcher Prüfungstyp soll erstellt werden?') =>
  XNativeDialog.showPopup<ExamType>({
    modal: true,
    content: (resolve, reject) => html`
      <x-flex padding="md" space="sm">
        <x-h3> ${title} </x-h3>
        ${Object.values(ExamType).map(
          value => html`
            <x-button tone=${getToneForExamType(value)} @click=${() => resolve(value)}>
              ${clientTranslator.translate('examType', value, 'long')} (${value})
            </x-button>
          `,
        )}
        <x-button mode="outline" @click=${() => reject()}> Abbrechen </x-button>
      </x-flex>
    `,
  });
